import React from "react";
import { EventStatus } from "@prestosports/prestostats-core/Common";
import { useTeamsContext } from "../../../state/teams/context";
import { useGameContextContext } from "../../../state/game-context/context";
import { useEventContext } from "../../../state/events/context";
import ScoreBoard from "../components/ScoreBoard";
import { toDisplayMs } from "../../football/components/utils/PlayUtils";

const ScoreBoardContainer = () => {
	const { state: teamState } = useTeamsContext();
	const homeTeam = teamState.homeTeam();
	const awayTeam = teamState.awayTeam();

	const { state: gameContextState } = useGameContextContext();
	const swapTeams = gameContextState.swapTeams();
	const homeScore = gameContextState.homeScore();
	const visitorScore = gameContextState.visitorScore();
	const gameClock = gameContextState.gameClock();
	const gameConfig = gameContextState.gameConfig();
	// gameClock may be a revived instance (now is a method) or a
	// serialized payload (now is a number); display per Clock Type.
	const nowMs =
		typeof gameClock?.now === "function" ? gameClock.now() : gameClock?.now || 0;
	const periodNumber = gameContextState.period();
	const now = toDisplayMs(nowMs, gameConfig, periodNumber);

	const { state: eventState } = useEventContext();
	const currentEvent = eventState.currentEvent();
	const isFinal = currentEvent ? EventStatus.isFinal(currentEvent) : false;
	const { venue, sportId, startDateTime } = currentEvent;

	return (
		<ScoreBoard
			swapTeams={swapTeams}
			awayTeam={awayTeam}
			awayScore={visitorScore}
			homeTeam={homeTeam}
			homeScore={homeScore}
			startDateTime={startDateTime}
			venue={venue}
			periodNumber={periodNumber}
			time={now}
			isFinal={isFinal}
			sportId={sportId}
		/>
	);
};

export default ScoreBoardContainer;
